/**
 * @generated SignedSource<<3dd03a1a1425feea730e336b02de8499>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UtilizationGrantPermission = "END_ON_OPEN" | "END_RENTAL" | "UNLOCK" | "%future added value";
export type endRentalPageQuery$variables = {
  reservationId: string;
};
export type endRentalPageQuery$data = {
  readonly reservation: {
    readonly id?: string;
    readonly space?: {
      readonly frame: string;
      readonly id: string;
      readonly position: number;
    };
    readonly subtype?: {
      readonly __typename: string;
    };
    readonly utilizationGrants?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly permissions: ReadonlyArray<UtilizationGrantPermission>;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type endRentalPageQuery = {
  response: endRentalPageQuery$data;
  variables: endRentalPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reservationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "reservationId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "subtype",
  "plural": false,
  "selections": [
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "frame",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "active": true
      }
    },
    {
      "kind": "Literal",
      "name": "pagination",
      "value": {
        "page": 0,
        "pageSize": 1000
      }
    }
  ],
  "concreteType": "UtilizationGrantPage",
  "kind": "LinkedField",
  "name": "utilizationGrants",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UtilizationGrant",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "permissions",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "utilizationGrants(filter:{\"active\":true},pagination:{\"page\":0,\"pageSize\":1000})"
},
v7 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v8 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "endRentalPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              {
                "kind": "CatchField",
                "field": (v6/*:: as any*/),
                "to": "NULL"
              }
            ],
            "type": "LockReservation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "endRentalPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "type": "LockReservation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "185b2604b0e9d823a2b5df6527e6f825",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "reservation": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Reservation"
        },
        "reservation.__typename": (v7/*:: as any*/),
        "reservation.id": (v8/*:: as any*/),
        "reservation.space": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Space"
        },
        "reservation.space.frame": (v7/*:: as any*/),
        "reservation.space.id": (v8/*:: as any*/),
        "reservation.space.position": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Int"
        },
        "reservation.subtype": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservationSubtype"
        },
        "reservation.subtype.__typename": (v7/*:: as any*/),
        "reservation.utilizationGrants": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "UtilizationGrantPage"
        },
        "reservation.utilizationGrants.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrant"
        },
        "reservation.utilizationGrants.nodes.id": (v8/*:: as any*/),
        "reservation.utilizationGrants.nodes.permissions": {
          "enumValues": [
            "END_RENTAL",
            "UNLOCK",
            "END_ON_OPEN"
          ],
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrantPermission"
        }
      }
    },
    "name": "endRentalPageQuery",
    "operationKind": "query",
    "text": "query endRentalPageQuery(\n  $reservationId: UUID!\n) {\n  reservation(id: $reservationId) {\n    __typename\n    ... on LockReservation {\n      id\n      subtype {\n        __typename\n      }\n      space {\n        id\n        frame\n        position\n      }\n      utilizationGrants(filter: {active: true}, pagination: {page: 0, pageSize: 1000}) {\n        nodes {\n          id\n          permissions\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c776404b3bd53b4be768919108d5b006";

export default node;
